import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "" }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span className="mask-line" key={i}>
                <motion.span
                    className={lineClassName}
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.9, delay: 0.15 + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export const SectionHead = ({ eyebrow, title, sub, dark = false, center = false, as: Tag = "h2" }) => (
    <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
        <p className="text-xs uppercase tracking-[0.3em] font-mono font-semibold text-gold-deep mb-4" data-testid="section-eyebrow">
            {eyebrow}
        </p>
        <Tag className={`font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight ${dark ? "text-white" : "text-navy"}`}>
            {title}
        </Tag>
        {sub && (
            <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
                {sub}
            </p>
        )}
    </Reveal>
);
